/* @ngInject */
export default function MainGridHamburgerMenuCtrl(
  nvCurrentPage,
) {
  const vm = this;

  vm.nvCurrentPage = nvCurrentPage;
}
